import { render, staticRenderFns } from "./ModalResendReminderProgressMassive.vue?vue&type=template&id=6b1dfe91&scoped=true&"
import script from "./ModalResendReminderProgressMassive.vue?vue&type=script&lang=js&"
export * from "./ModalResendReminderProgressMassive.vue?vue&type=script&lang=js&"
import style0 from "./ModalResendReminderProgressMassive.vue?vue&type=style&index=0&id=6b1dfe91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1dfe91",
  null
  
)

export default component.exports